import { orders } from '~/plugins/shopify/objects/orders'
// https://shopify.dev/docs/api/storefront/2024-04/queries/customer
export const customerOrders = `
query customerOrders($customerAccessToken: String!, $cursor: String!) {
  customer(customerAccessToken: $customerAccessToken) {
    orders(first: 10, reverse: true, after: $cursor) ${orders}
  }
}`
